/**
 * use this file to define common validation constants/strings/messages
 */

const VALIDATION_SCHEMA_CONSTANTS = {
  ALLOW_LIST_UNQIUE_USER_ID: 'This user ID is already in use',
  AUDIENCE_CONDITIONS_CONTAINS_NOT_OPERATOR:
    'Audience Conditions must not use the "not" operator in order to use Non-Code Mode.',
  AUDIENCE_CONDITIONS_DUPLICATE_AUDIENCE_IDS:
    'Audience Conditions must not contain duplicate "audience_id" values.',
  AUDIENCE_CONDITIONS_INVALID_JSON: 'Audience conditions must be valid JSON',
  AUDIENCE_CONDITIONS_INVALID_LEAF_KEY:
    'Only the key "audience_id" can be used for Audience combinations.',
  AUDIENCE_CONDITIONS_INVALID_OPERATOR:
    'A valid operator ("or", "and", or "not") must be used.',
  AUDIENCE_CONDITIONS_NESTED_CONDITIONS:
    'Audience Conditions must not contain nested conditions in order to use Non-Code Mode.',
  AUDIENCE_CONDITIONS_NOT_OPERATOR_NEGATES_SINGLE_CONDITION_OR_LIST:
    'The "not" operator must be used with a single condition or list.',
  CHARACTER_LIMIT_64: 'Please limit key length to 64 characters',
  DEFAULT_VALUE_OUT_OF_RANGE: 'Must be within the minimum and maximum',
  DOES_NOT_CONTAIN_DELETED_KEY_REGEX: /^((?!\w+!deleted_\d+$).)*$/,
  DOES_NOT_CONTAIN_PLACEHOLDER: /^(?!\$placeholder$)/,
  DUPLICATE_KEY: 'Please enter a unique key',
  EMPTY_DATE: 'Date required',
  EMPTY_ENV: 'Environment required',
  EMPTY_KEY: 'Please enter a key',
  EMPTY_NAME: 'Please enter a name',
  EMPTY_OUTCOME: 'Please select an outcome',
  EMPTY_REASON: 'Please enter the reason',
  EMPTY_SCHEDULE: 'You need to schedule at least one change',
  EMPTY_TIME: 'Time required',
  EMPTY_TIMEZONE: 'Timezone required',
  EMPTY_USER_ID: 'Please enter a valid user ID',
  EMPTY_VALUE: 'Please enter a value',
  EMPTY_VARIATION: 'Please select a variation',
  FX_BOUNCE_EXIT_RATE:
    'Feature Experimentation does not support bounce rate or exit rate metrics.',
  INVALID_RATIO_METRICS:
    'SA/MAB experiment types do not yet support ratio metrics, please remove them to start this type of experiment.',
  INVALID_VARIATION:
    'One or more variations have been removed from this experiment. Add it back or reassign the user(s)',
  JSON_OBJECT:
    'Optimizely only supports top level JSON objects. JSON arrays must be nested inside a JSON object.',
  NO_METRICS: 'Please add at least one metric',
  RANGE_MAX_ERROR: 'Must be larger than minimum',
  RANGE_MIN_ERROR: 'Must be smaller than maximum',
  STATS_ACCELERATOR_MIN_VARIATIONS:
    'Stats Accelerator requires at least 3 total variations',
  WRONG_TRAFFIC_DISTRIBUTION: 'The traffic distribution total must equal 100%.',
};

const CONSTANTS = {
  GroupSelectionWarningMessage:
    'Changing traffic allocation or group assignment for a running experiment will impact user bucketing, causing users to be bucketed in or unbucketed from this experiment.',
  GroupsWarningMessage:
    'Changing traffic allocation or group assignment for a running experiment will impact user bucketing, causing users to be bucketed in or unbucketed from this experiment. Are you sure you want to proceed with this change?',
  SAMetricsWarningMessage:
    'Unique conversion rates are more stable and make Stats ' +
    'Accelerator predictions of statistical significance more reliable. ' +
    'To use a numerically-valued primary metric, such as total conversions or ' +
    'revenue per visitor, select Manual distribution or use a Multi-armed bandit.',

  SAVariationWarningHeader: 'Add more variations to use Stats Accelerator',
  SAVariationWarningMessage:
    'Stats Accelerator requires at least 3 total variations, ' +
    'including your Original. If you only want to use two variations, ' +
    'use an A/B experiment. ',
  TrafficDistributionWarningMessage:
    'Changing traffic allocation on a running experiment will impact the integrity of your results because of a problem known as Simpson’s Paradox. If this change is still necessary, it is encouraged to pause this experiment, duplicate it, and publish the new one.',
};

export { VALIDATION_SCHEMA_CONSTANTS, CONSTANTS };
